<template>
    <div class="content-wrap">
        <section class="section content-section-01 no-padding-top">
            <div class="container">
                <div class="row middle-md">
                    <div class="col-xs-12 col-md-6">
                        <div class="sub-section">
                            <h2 class="headline_h1 sub-title">
                                Lokal an PKW.de-Partnerhändler verkaufen
                            </h2>

                            <ul>
                                <li>Preisbewertung in unter 1 Minute erhalten</li>
                                <li>Termin bei einer PKW.de-Ankaufstation in deiner Nähe bequem online buchen</li>
                                <li>Ankaufangebot von geprüften Händlern erhalten</li>
                                <li>Kein Zwang - nur verkaufen, wenn dir das Angebot zusagt</li>
                                <li>Bezahlung in bar oder per Sofortüberweisung</li>
                                <li>Abmeldung ist inklusive</li>
                            </ul>

                            <div class="action-block">
                                <button class="text-wrapper__btn" @click="makeRedirect">
                                    <i class="fa fa-map-marker"></i>
                                    Auto verkaufen <i class="fas fa-arrow-right" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-gi-5 image-col">
                        <img src="../assets/base/auto_verkaufen_lokal.png" alt="Auto lokal verkaufen" />
                    </div>
                </div>
            </div>
        </section>
        <section class="funktioniert-local-verkauf">
            <div class="container">
                <div class="row">
                <div class="col-xs-12 col-lg-12">
                    <h2 class="headline_h1">
                        Lokal verkaufen: <span class="make-red">So funktioniert es</span>
                    </h2>
                    <ul class="step-list">
                    <li class="step">
                        <div class="step-block">
                        <img
                            src="../assets/icons/step-1.svg"
                            alt="Preisbewertung in 1 Minute erhalten"
                        />
                        <p>Preisbewertung in 1 Minute <br/>erhalten</p>
                        </div>
                    </li>
                    <li class="step">
                        <div class="step-block">
                        <img
                            src="../assets/icons/local/step-2.svg"
                            alt="Termin bei PKW.de-Ankaufstation in der Nähe buchen"
                        />
                        <p>
                            Termin bei PKW.de-<br/>Ankaufstation in der Nähe <br/>buchen
                        </p>
                        </div>
                    </li>
                    <li class="step">
                        <div class="step-block">
                        <img
                            src="../assets/icons/local/step-3.svg"
                            alt="Vor Ort Auto begutachten lassen und Angebot bekommen"
                        />
                        <p>
                            Vor Ort Auto begutachten <br/>lassen und Angebot bekommen
                        </p>
                        </div>
                    </li>
                    <li class="step">
                        <div class="step-block">
                        <img
                            src="../assets/icons/local/step-4.svg"
                            alt="Auto verkaufen und Geld in bar oder per Sofortüberweisung erhalten"
                        />
                        <p>
                            Auto verkaufen und Geld in bar <br/>oder per Sofortüberweisung <br/>erhalten
                        </p>
                        </div>
                    </li>
                    <li class="step">
                        <div class="step-block">
                        <img
                            src="../assets/icons/local/step-5.svg"
                            alt="Abmeldung übernimmt der Händler"
                        />
                        <p>
                            Abmeldung übernimmt der <br/>Händler
                        </p>
                        </div>
                    </li>
                    </ul>

                    <div class="action-block text-align">
                    <button @click="makeRedirect"><i class="fa fa-map-marker"></i> Auto verkaufen <i class="fa fa-arrow-right"></i></button>
                    </div>
                </div>
                </div>
            </div>
        </section>
        <section class="section content-section-02">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 col-md-6 col-gi-5 image-col">
                        <img src="../assets/local/local-content-img.jpeg" alt="Lokal verkaufen" class="section-img" />
                    </div>
                    <div class="col-xs-12 col-md-6 col-gi-offset-1 ">
                        <div class="sub-section sub-section-01">
                            <h2 class="headline_h1 sub-title">
                                Lokal verkaufen: <span class="make-red">Schritt für Schritt erklärt</span>
                            </h2>

                            <ol>
                                <li>
                                    <strong>Preisbewertung in 1 Minute erhalten</strong>
                                    <p>Bei unserer Preisbewertung gibst du Informationen zu Marke, Modell und Erstzulassung ein und vervollständigst die Angaben zur Motorisierung, Ausstattung und Kilometerstand deines Autos. <br/>Du bekommst per E-Mail sofort eine erste Preisbewertung zugeschickt.</p>
                                </li>
                                <li>
                                    <strong>Termin bei einer PKW.de-Ankaufstation buchen</strong>
                                    <p>Nachdem du die Preisbewertung erhalten hast, buchst du bequem einen Termin bei einem PKW.de-Partnerhändler in deiner Nähe. Falls du lieber von zu Hause verkaufen möchtest – kannst du auch online verkaufen.</p>
                                </li>
                                <li>
                                    <strong>Auto vor Ort begutachten lassen</strong>
                                    <p>Bei einem PKW.de-Partnerhändler lässt du dein Auto vor Ort begutachten und erhältst anhand des Zustands des Wagens ein Angebot. Du entscheidest dich, ob du zu diesem Preis verkaufen möchtest oder nicht.</p>
                                </li>
                                <li>
                                    <strong>Auto verkaufen und sofort Geld erhalten</strong>
                                    <p>Wenn du das Auto zum Angebot der Ankaufstation verkaufen möchtest, erhältst du das Geld vom Händler in bar oder per Sofortüberweisung. Du übergibst die Fahrzeugschlüssel, Zulassungsbescheinigung Teil 1 + 2 (Fahrzeugschein und Fahrzeugbrief) und (falls vorhanden) die Bestätigung der letzten Haupt- und Abgasuntersuchung sowie Werkstattrechnungen.</p>
                                </li>
                                <li>
                                    <strong>Abmeldung</strong>
                                    <p>Die Abmeldung des Fahrzeugs beim Straßenverkehrsamt und der Versicherung übernimmt der Händler. Du musst dich um nichts kümmern.</p>
                                </li>
                            </ol>
                        </div>
                    </div>
                    
                </div>
            </div>
        </section>
        <section class="section section-highlight content-section-04">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12">
                        <ContactForm />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { redirectToEvaluationNew } from '../services/helpers';
import ContactForm from './ContactForm';

export default {
    name: "ContentBlock",
    components: {
        ContactForm,
    },
    computed: {
        $clientOnly() {
            return typeof window !== 'undefined'; // Checks for browser environment
        }
    },
    methods: {
        makeRedirect() {        
            redirectToEvaluationNew(this.$store, true, 'trade_in', 'local_lp');
        },
    }
}
</script>

<style lang="scss" scoped>
    @import "~@/assets/vars";

    .fa.fa-map-marker {
        font-family: 'FontAwesome';
        font-weight: 400;

        button & {
            font-size:24px;
        }
    }

    h2.headline_h1 {
        margin-bottom:30px !important;
        @include breakpoint(fromlarge) {
            text-align:center;
            padding:0;
            
            &:before {
                display:none;
            }

            
            br {
                display:none;
            }
        }
        @include breakpoint(extralarge) {
            font-size: 48px;
            margin-bottom: 72px !important;
        }
    }

    h1,
    h2,
    h3 {
        span {
            display:inline;
        }

        .make-red {
            color: $red;
            display:inline;
            font-size: inherit;
            line-height: inherit;
        }
    }

    .content-wrap .text-wrapper {

        &__btn i {
            padding-left: 10px;
        }
        .text-margin {
            margin-bottom: 30px;
        }

        
    }
    .contact-form-section {
        padding:0;
    }
    .section {
        padding:50px 0;

        @include breakpoint(fromgiant) {
             padding:100px 0;
        }

        
        &.section-highlight {
            background:$light-gray;
        }

        .margin-top {
            margin-top:16px;
            
            @include breakpoint(fromgiant) {
                margin-top:42px;
            }
        }
        &.no-padding-top {
            padding-top:0;
        }
        .margin-bottom {
            margin-bottom:16px;
            
            @include breakpoint(fromgiant) {
                margin-bottom:42px;
            }
        }

        .image-col {
            display:none;

            @include breakpoint(frommediumlarge) {
                display:block;
            }
        }

        .section-img {
            border-radius: 13px;
        }

        .sub-section {
            margin-top:30px;

            .action-block {
                padding-top:10px;
                display:flex;
                flex-direction: column;
                align-items: center;

                @include breakpoint(frommediumlarge) {
                    margin-top:20px;
                }

                @include breakpoint(fromlarge) {
                    // align-items: flex-start;
                    max-width: 340px;
                    margin-left:60px;
                    margin-top:50px;

                    &.text-only {
                        margin-top:0;
                        margin-left:120px;
                    }
                }

                button {
                    margin-bottom:7px;
                    white-space: nowrap;
                }

                .text-button {
                    text-decoration: underline;
                    color: $black-variant;

                    &:hover {
                        text-decoration: none;
                    }
                }
            }
        }

        .sub-title {
            @include breakpoint(fromlarge) {
                font-size: 40px;
                line-height: 50px;
                text-align:left;
                margin-bottom:40px !important;
            }
        }

        ul {
            padding:0;
            li {
                position:relative;
                padding-left:25px;
                font-size: 18px;
                line-height: 30px;

                &:before {
                    content: "\f00c";
                    font-family: 'Font Awesome 5 Free';
                    font-weight: 700;
                    display: block;
                    color: $red;
                    font-size: 16px;
                    position: absolute;
                    left: 0;
                    top: 0;
                }
            }
        }

        ol {
            padding-left:0;
            list-style: none;
            counter-reset: my-counter;
            margin-bottom:0;

            li {
                padding-left:25px;
                counter-increment: my-counter;
                list-style: none;
                position: relative;

                &:before {
                    content: counter(my-counter);
                    background-color: $black-variant;
                    color: $white;
                    font-weight: bold;
                    width: 17px;
                    height: 17px;
                    border-radius: 100%;
                    position:absolute;
                    font-size: 11px;
                    left:0;
                    top:3px;
                    display:flex;
                    align-items:center;
                    justify-content: center;
                }

                &:last-of-type {
                    margin-bottom:0;
                    &:before {
                        content: "\f00c";
                        font-family: 'FontAwesome';
                        font-size:10px;
                        font-weight: normal;
                    }
                }

                strong {
                    font-size: 18px;
                }
            }
        }

        .headline_h1 {
            @include breakpoint(fromlarge) {
                padding:0;
                
                &:before {
                    display:none;
                }

                
                br {
                    display:none;
                }
            }
        }

        &.content-section-02 {
            padding-top:0;
            .image-col {
                padding-top:120px;
            }
        }
    }

    .table.ratings {
        max-width: 910px;
        margin:20px auto 0;

        @include breakpoint(fromlarge) {
            margin:0 auto;
        }
        
        .table-row {
            border-bottom:1px solid #c7c7c7;
            display:flex;

            &:last-of-type {
                border-bottom: 0 none;
            }

            .table-cell {
                flex:1;
                height: 54px;
                display:flex;
                align-items:center;
                justify-content: center;
                border-right: 1px solid #c7c7c7;

                @include breakpoint(fromlarge) {
                    height: 113px;
                    font-size: 24px;
                    line-height: 34px;
                }

                &:last-of-type {
                    border-right:0 none;
                }

                .fa-star {
                    color: #FFD740;

                    @include breakpoint(fromlarge) {
                        font-size: 22px;
                    }
                }
                .fa.fa-star.fa-outlined {
                    font-weight: 400;
                    color:#E7E7E7;
                }

                svg {
                    width: 18px;
                }

                &.head-cell {
                    font-weight: bold;
                    gap: 5px;

                    @include breakpoint(fromlarge) {
                        font-size: 34px;
                        line-height: 34px;
                        gap:15px;
                    }

                    &.local {
                        svg {
                            @include breakpoint(fromlarge) {
                                width: 24px;
                                height: 40px;
                            }
                        }
                    }

                    &.online {
                        svg {
                            @include breakpoint(fromlarge) {
                                width: 43px;
                                height: 34px;
                            }
                        }
                    }
                }

                &.main-cell {
                    flex-direction: column;

                    @include breakpoint(fromlarge) {
                        flex-direction: row;
                        gap:10px;

                        svg {
                            width: 39px;
                            height: 38px;
                        }
                    }
                }
            }
        }
    }

    .funktioniert-local-verkauf {
        padding-top: 25px;

        @include breakpoint(fromgiant) {
        display:block;
        padding-top:0;
        }
        .action-block {
        padding-top:20px;
        margin-bottom:35px;
        @include breakpoint(frommediumlarge) {
            padding-top: 0;
            margin-bottom: 50px;
        }
        @include breakpoint(fromgiant) {
            padding-top: 61px;
            margin-bottom: 75px;
        }
        }
    }

  ul.step-list {
    padding: 15px 0 0;
    width: 100%;

    @include breakpoint(fromlarge) {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
    }

    @include breakpoint(fromgiant) {
      padding: 25px 0 0;
    }

    @include breakpoint(extralarge) {
      padding: 25px 50px 0;
    }

    li {
      
      width:100%;
      position:relative;

      @include breakpoint(fromlarge) {
        width:20%;
        text-align: center;
      }

      .step-block {
        display:flex;
        align-items: center;
        margin-bottom:20px;

        @include breakpoint(frommediumlarge) {
          margin-bottom:40px;
        }

        @include breakpoint(fromlarge) {
          display:block;
          padding:0 10px;
        }

        @include breakpoint(fromgiant) {
          margin-bottom:0;
        }

        @include breakpoint(full) {
          padding:0;
        }

        br {
          display:none;
          @include breakpoint(full) {
            display:block;
          }
        }

        img {
          width:75px;
          margin-right:22px;

          @include breakpoint(fromlarge) {
            margin-right:0;
          }

          @include breakpoint(fromgiant) {
            width:auto;
            
          }
        }

        p {
          margin-bottom:0;
          @include breakpoint(fromlarge) {
            font-size:16px;
            font-weight: bold;
          }
        }
      }

    //   &:last-of-type {
    //     &:after {
    //       display:none;
    //     }
    //   }
      
    //   @include breakpoint(fromlarge) {
    //     &:after {
    //       content:"";
    //       display:block;
    //       height: 1px;
    //       background: $border-dark;
    //       width: 63px;
    //       position:absolute;
    //       right:-35px;
    //       top:40px;
    //     }
    //   }

    //   @include breakpoint(fromgiant) {
    //     &:after {
    //       top:63px;
    //     }
    //   }
      img {       

        @include breakpoint(fromgiant) {
          margin-bottom: 26px;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/local-components/ContentBlock.vue